import TextCoreCounterInline from "./TextCoreCounterInline";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("CounterInline", TextCoreCounterInline);
